<template>
  <div class="dropdown" v-if="hasCards">
    <div :class="classObject()" ref="button" @click="openDropdown">
      <h2 class="dropdown-button__name">
        <span class="number">{{ getNumber() }}</span>
        <span class="name">{{ dropdown.name }}</span>
      </h2>
      <div class="dropdown-button__result" v-if="window.width < 1200">
        {{ result }}
      </div>
      <div class="dropdown-button__icon icon">
        <caret-svg />
      </div>
    </div>

    <transition
        name="accordion"
        @enter="start"
        @after-enter="end"
        @before-leave="start"
        @after-leave="end">
      <div class="dropdown__content" v-if="visible">
        <div class="dropdown__wrapper" ref="content">
          <div v-if="divanMaterial">
            <button type="button" role="button" :aria-label="options.selectSame.btn"
                    class="dropdown__button-same button-same"
                    :class="{'is-active': isTheSameActive}"
                    @click="toggleTheSame">
              <span class="name">{{ options.selectSame.btn }}</span>
              <span class="line"></span>
              <span class="icon" v-if="isTheSameActive">
                        <check-svg/>
                      </span>
            </button>
          </div>

          <form class="dropdown__form previews-form">
            <div
              class="previews-form__item previews"
              v-for="item in dropdown.items"
              v-if="item.items && item.items.length"
            >
              <h3 class="previews__title" v-if="item.name">
                <span class="name">{{ item.name }}</span>
                <span class="line"></span>
              </h3>
              <div
                class="previews__list preview-list"
                :class="{'has-material': material, 'has-less' : !material && item.items.length < 5}"
                v-if="item.items && item.items.length"
              >
                <div class="preview-list__item" v-for="item in item.items">
                  <preview-card
                    :card="item"
                    :value="selectedValue"
                    :material="material"
                    :dropdown-id="dropdownId"
                    :is-active="item.selected === 'selected'"
                    @checked="showResults(item)"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import CaretSvg from '../../../../../assets/img/icons/caret.svg';
import CheckSvg from '../../../../../assets/img/icons/check.svg';
import previewCard from './previewCard.vue';
import { mixin } from '../../mixin';

export default {
  name: 'dropdownItem',
  mixins: [mixin],
  components: {
    previewCard,
    CaretSvg,
    CheckSvg,
  },
  props: {
    inx: Number,
    dropdown: Object,
    dropdownId: String,
  },
  inject: ['Accordion'],
  data() {
    return {
      hasCards: false,
      selectedValue: '',
      result: '',
      index: null,
      isTheSameActive: false,
      radioName: '',
      material: false,
      divanMaterial: false,
      divanActive: '',
    };
  },
  created() {
    this.index = this.Accordion.count++;

    this.checkCardsLength();

    if (window) {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  },
  destroyed() {
    if (window) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
    storeResults() {
      return this.$store.state.selectedResult.model;
    },
    fabric() {
      return this.$store.state.fabric;
    },
    visible() {
      return this.index === this.Accordion.active;
    },
  },
  mounted() {
    this.setRadioName();
  },
  methods: {
    classObject() {
      return {
        'dropdown__button dropdown-button': true,
        'has-result': this.result !== '',
        'is-active': this.visible,
      };
    },
    setRadioName() {
      this.dropdown.items.forEach((item) => {
        if (item.items && item.items.length) {
          item.items.forEach((subItem) => {
            this.radioName = subItem.action_id;
            this.material = subItem.action_id.includes('mtl');
            this.divanMaterial = subItem.action_id.includes('divan:mtl');
          });
        }
      });
    },
    checkCardsLength() {
      this.dropdown.items.forEach((item) => {
        if (item.items && item.items.length) {
          this.hasCards = true;
        }
      });
    },
    getNumber() {
      if (this.inx < 9) {
        return `0${this.inx + 1}`;
      } else {
        return `${this.inx + 1}`;
      }
    },
    openDropdown() {
      if (this.visible) {
        this.Accordion.active = null;
      } else {
        this.Accordion.active = this.index;
      }

      // for the same btn
      this.dropdown.items.forEach(item => {
        if (item.items[0].action_id === 'divan:mtl') {
          if (this.divanActive !== '') {
            this.isTheSameActive = this.divanActive === this.fabric;
          } else {
            this.isTheSameActive = item.items[0].name === this.fabric;
          }
        }
      })
    },
    start(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    end(el) {
      el.style.height = '';
    },
    toggleTheSame() {
      this.dropdown.items.forEach(item => {
        item.items.forEach(subItem => {
          if (subItem.name === this.fabric) {
            document.getElementById(subItem.action).click();
            this.isTheSameActive = true;
          }
        })
      })
    },
    showResults(item) {
      this.result = item.name;
      this.$emit('result', {
        id: this.getNumber(),
        name: this.dropdown.name,
        result: this.result,
      });

      // for the same btn
      if (item.action_id === 'hb:mtl') {
        this.isTheSameActive = false;
      }
      if (item.action_id === 'divan:mtl') {
        this.isTheSameActive = this.result === this.fabric;
        this.divanActive = this.result;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}

.dropdown {
  .dropdown-button {
    padding: 10px 22.83px 10px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    white-space: nowrap;
    cursor: pointer;

    @include up-tablet {
      padding: 15px 52px 9.5px;
    }

    @include up-laptop {
      padding-right: 32px;
      padding-left: 32px;
    }

    .touch & {
      @media (min-width: 1024px) and (orientation: landscape) {
        padding-right: 32px;
        padding-left: 32px;
      }

      @include up-laptop {
        padding-right: 32px;
        padding-left: 32px;
      }
    }

    &.is-active,
    &.has-result {
      .dropdown-button {
        &__name {
          .number {
            background-color: $c-light-beige;
            border-color: $c-light-beige;
          }
        }
      }
    }

    &.is-active {
      .icon {
        transform: rotate(180deg);
      }
    }

    &__name {
      margin-right: 38px;
      display: flex;
      align-items: center;
      font-family: $f-neutraBook;

      @include up-tablet {
        position: relative;
        padding-left: 46px;
      }

      @include up-laptop {
        padding-left: 44px;
      }

      .number {
        margin-right: 14px;
        width: 32px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        line-height: 21px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        @include anim();

        @include up-tablet {
          position: absolute;
          left: 0;
          top: -4px;
          font-size: 18px;
          line-height: 21px;
        }
      }

      .name {
        font-size: 16px;
        line-height: 1.25;
        text-transform: uppercase;

        @include up-tablet {
          font-size: 22px;
        }
      }
    }

    &__result {
      margin: 0 20px 0 auto;
      max-width: 84px;
      font-family: $f-bellReg;
      font-size: 12px;
      line-height: 15px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @include up-tablet {
        margin: 0 27px 0 auto;
        max-width: 100%;
        font-size: 13px;
        line-height: 15px;
      }
    }

    &__icon {
      transform: rotate(0);
      @include anim();
    }
  }

  &__content {
    //height: 0;
    overflow: hidden;
    @include anim();
  }

  &__button-same {
    padding: 28px 20px 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @include up-laptop {
      padding: 27.24px 47px 0 49px;
    }

    &.is-active {
      .line {
        @include up-tablet {
          margin: 0 19.5px 0 15.5px;
        }

        @include up-laptop {
          margin: 0 15px 0 16px;
        }
      }
    }

    .touch & {
      @media (min-width: 1024px) and (orientation: landscape) {
        padding: 27.24px 20px 0 20px;
      }

      @include up-laptop {
        padding: 27.24px 47px 0 49px;
      }
    }

    .name {
      flex: none;
      margin-right: 20px;
      min-height: 33px;
      display: flex;
      align-items: center;
      font-family: $f-neutraBook;
      font-size: 14px;
      line-height: 20px;
      text-transform: uppercase;

      @include up-tablet {
        margin-right: 0;
      }
    }

    .line {
      @include up-tablet {
        margin: 0 0 0 15.5px;
        flex-grow: 1;
        width: 100%;
        height: 1px;
        background-color: rgba(0, 0, 0, 0.1);
        transition: margin .5s ease;
      }

      @include up-laptop {
        margin: 0 0 0 16px;
      }
    }

    .icon {
      display: flex;
    }
  }

  &__form {
    padding: 18px 20px 2px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    @include up-laptop {
      padding: 25px 47px 25px 49px;
    }

    .touch & {
      @media (min-width: 1024px) and (orientation: landscape) {
        padding: 25px 20px;
      }

      @include up-laptop {
        padding: 25px 47px 25px 49px;
      }
    }
  }

  .previews {
    &__title {
      margin-bottom: 11px;
      display: flex;
      align-items: center;

      @include up-tablet-plus {
        margin-bottom: 13px;
      }

      .name {
        margin-right: 9.85px;
        flex: none;
        font-family: $f-neutraBook;
        font-size: 12px;
        line-height: 20px;
        text-transform: uppercase;

        @include up-tablet {
          margin-right: 11px;
          font-size: 14px;
          line-height: 15px;
        }

        @include up-laptop {
          //font-size: 14px;
          line-height: 20px;
        }
      }

      .line {
        flex-grow: 1;
        width: 100%;
        height: 1px;
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    &__list {
      margin-bottom: 16px;

      @include up-tablet {
        margin-bottom: 18px;
      }
    }

    .preview-list {
      display: grid;
      grid-template-columns: repeat(4, minmax(0, 1fr));
      grid-column-gap: 20.63px;
      grid-row-gap: 11px;
      min-height: 0;
      min-width: 0;

      @include up-tablet {
        grid-template-columns: repeat(8, minmax(0, 1fr));
        grid-column-gap: 26.63px;
        grid-row-gap: 18px;
      }

      @include up-laptop {
        grid-template-columns: repeat(4, minmax(0, 1fr));
        grid-column-gap: 20.63px;
        grid-row-gap: 17px;
      }

      @include up-desktop {
        grid-template-columns: repeat(5, minmax(0, 1fr));
      }

      .touch & {
        @media (min-width: 1024px) and (orientation: landscape) {
          grid-template-columns: repeat(5, minmax(0, 1fr));
        }

        @include up-laptop {
          grid-template-columns: repeat(4, minmax(0, 1fr));
          grid-column-gap: 20.63px;
          grid-row-gap: 17px;
        }

        @include up-desktop {
          grid-template-columns: repeat(5, minmax(0, 1fr));
        }
      }
    }
  }
}
</style>
